import { render, staticRenderFns } from "./ReleaseGPsManagerForm.vue?vue&type=template&id=7d6dd6fe&"
import script from "./ReleaseGPsManagerForm.vue?vue&type=script&lang=ts&"
export * from "./ReleaseGPsManagerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports